export var CanvasModel = (function () {
    function CanvasModel(el) {
        this.el = el;
        this._context = null;
        this._canvas = null;
        this._canvasOffset = null;
    }
    Object.defineProperty(CanvasModel.prototype, "Canvas", {
        get: function () {
            if (this._canvas == null) {
                this._canvas = this.el.nativeElement;
            }
            return this._canvas;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasModel.prototype, "Context2d", {
        get: function () {
            if (this._context == null) {
                this._context = this.Canvas.getContext('2d');
            }
            return this._context;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasModel.prototype, "Offset", {
        get: function () {
            if (this._canvasOffset == null) {
                this.updateOffset();
            }
            return this._canvasOffset;
        },
        enumerable: true,
        configurable: true
    });
    CanvasModel.prototype.clear = function (footprint, zoom) {
        this.Context2d.fillStyle = "white";
        this.Context2d.fillRect(0, 0, footprint.width * zoom, footprint.height * zoom);
    };
    CanvasModel.prototype.updateOffset = function () {
        this._canvasOffset = this.getOffsetSum(this.Canvas);
    };
    CanvasModel.prototype.getOffsetSum = function (elem) {
        var top = 0, left = 0;
        while (elem) {
            top = top + elem.offsetTop;
            left = left + elem.offsetLeft;
            elem = elem.offsetParent;
        }
        return { top: top, left: left };
    };
    return CanvasModel;
}());
//# sourceMappingURL=canvas.model.js.map